import { ModalService } from './../modal-service/ModalService';
import { Injectable } from '@angular/core';
import { UserManagerService } from './userManager/user-manager.service';

@Injectable({
  providedIn: 'root'
})
export class KycService {
  loadingKYC = false;
  constructor(
    private userService: UserManagerService,
    private modalService: ModalService,
  ) {}

  startKycProcess(clientId:string, sessionId: string | null = null) {
    this.loadingKYC = true;
    return this.userService.initializeKYC(clientId, sessionId).then((res) => {
      // redirect user to kyc platform if is a success response
      if(res.erc == "1" && res.hasOwnProperty("erc")){
        window.location.href = res.data.url;
        return true;
      }else {
        // prompt user with an error message that initialization failed and he can do it
        // after login on his profil and redirect to home.
        this.modalService.openDialog( 'ml_error', 'kyc_connection_failed', false, true);
        console.error('KYC init error: ' + res.msg);
        setTimeout(() => {
          this.loadingKYC = false;
        }, 500);
        return false;
      }

    }).catch(err => {
        // prompt user with an error message that initialization failed and he can do it
        // after login on his profil and redirect to home.
        this.modalService.openDialog( 'ml_error', 'kyc_connection_failed', false, true);
        console.error('KYC init error: ' + err);
        this.loadingKYC = false;
        return false;
    });
  }
}
